import { Component } from '@angular/core';

/**
 * @author mscharf
 */
@Component({
    selector: 'terra-loading-spinner',
    styleUrls: ['./terra-loading-spinner.component.scss'],
    templateUrl: './terra-loading-spinner.component.html'
})
export class TerraLoadingSpinnerComponent {}
